<template>
  <v-app>
    <v-tabs v-model="active" color="primary" dark slider-color="yellow">
      <v-tab :key="1" ripple> {{ $t("drivers.createCaptain.driver") }} </v-tab>
      <v-tab-item>
        <v-container fluid>
          <v-layout align-start justify-space-around fill-height gap>
            <v-flex xs6 grow pr-4>
              <v-layout align-start justify-start column xs>
                <v-flex xs12>
                  <h1 class="headline">{{ $t("drivers.createCaptain.driverPersonalInfo") }}</h1>
                </v-flex>
                <v-flex xs12 mt-3 grow class="full-width">
                  <v-form ref="form" v-model="form" class="xs12 full-width">
                    <v-text-field
                      outline
                      v-model="model.first_name"
                      :rules="[rules.required]"
                      :label="$t('drivers.createCaptain.firstName')"
                      type="text"
                      grow
                    ></v-text-field>
                    <v-text-field
                      outline
                      v-model="model.last_name"
                      :rules="[rules.required]"
                      :label="$t('drivers.createCaptain.lastName')"
                      type="text"
                      grow
                    ></v-text-field>
                    <v-text-field
                      outline
                      v-model="model.phone_number"
                      :rules="[rules.required]"
                      :label="$t('drivers.createCaptain.phoneNumber')"
                      type="text"
                      grow
                    ></v-text-field>
                    <v-text-field
                      outline
                      v-model="model.username"
                      :rules="[rules.required]"
                      :label="$t('drivers.createCaptain.taxiNumber')"
                      type="text"
                      grow
                    ></v-text-field>
                    <v-text-field
                      outline
                      v-model="model.email"
                      :rules="[rules.email]"
                      :label="$t('drivers.createCaptain.emailAddress')"
                      type="text"
                      grow
                    ></v-text-field>

                    <v-text-field
                      outline
                      v-model="model.password"
                      :rules="[rules.password]"
                      :label="$t('drivers.createCaptain.password')"
                      type="password"
                      grow
                    ></v-text-field>
                    <v-select
                      outline
                      v-model="model.gender"
                      :label="$t('drivers.createCaptain.gender')"
                      :items="gender"
                      dense
                    ></v-select>

                    <v-select
                      outline
                      v-model="model.payment_method"
                      :label="$t('drivers.createCaptain.payment')"
                      :items="payment"
                      dense
                    ></v-select>

                    <v-select
                      outline
                      v-model="model.driver_constraints"
                      :label="$t('drivers.createCaptain.constraints')"
                      :items="captain_constraints"
                      multiple
                      dense
                    ></v-select>

             
                  </v-form>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6 grow pl-4>
             
            </v-flex>
          </v-layout>
          <v-btn @click="next" color="secondary" class="tbtn">{{ $t("drivers.createCaptain.proceed") }}</v-btn>
        </v-container>
      </v-tab-item>

      <v-tab :key="2" ripple> {{ $t("drivers.createCaptain.vehicle") }} </v-tab>
      <v-tab-item>
        <v-container fluid>
          <v-layout align-start justify-space-around fill-height gap>
            <v-flex xs6 grow pr-4>
              <v-layout align-start justify-start column xs>
                <v-flex xs12>
                  <h1 class="headline">{{ $t("drivers.createCaptain.vehicleInformation") }}</h1>
                </v-flex>
                <v-flex xs12 mt-3 grow class="full-width">
                  <v-form ref="form" v-model="form" class="xs12 full-width">
                    <!--<v-select
                                  outline
                                  v-model="model.brand"
                                  label="Brand"
                                  :items="allBrands"
                                  @change="getTypes"
                                  dense>
                                </v-select>-->

                    <v-autocomplete
                      v-model="model.brand"
                      :items="allBrands"
                      outline
                      hide-no-data
                      item-text="Description"
                      :label="$t('drivers.createCaptain.selectBrand')"
                      :placeholder="$t('drivers.createCaptain.startTyping')"
                      @change="getTypes"
                    ></v-autocomplete>
                    <!--<v-select
                                  id="ss"
                                  outline
                                  v-model="model.type"
                                  label="Type"
                                  :items="allTypes"
                                  :disabled="!model.brand"
                                  dense>
                                </v-select>-->

                    <v-autocomplete
                      v-model="model.type"
                      :items="allTest"
                      outline
                      hide-no-data
                      item-text="name"
                      item-value="id"
                      :label="$t('drivers.createCaptain.selectModel')"
                      :placeholder="$t('drivers.createCaptain.startTyping')"
                      :disabled="!model.brand"
                      return-object
                      @change="testFunction"
                    ></v-autocomplete>
                    <!--<v-select
                                  outline
                                  v-model="model.color"
                                  label="Color"
                                  :items="allColors"
                                  dense>
                                </v-select>-->

                    <v-autocomplete
                      v-model="model.color"
                      :items="allColors"
                      outline
                      hide-no-data
                      item-text="Description"
                      :label="$t('drivers.createCaptain.selectCarColor')"
                      :placeholder="$t('drivers.createCaptain.startTyping')"
                    ></v-autocomplete>

                    <v-text-field
                      outline
                      v-model="model.bluetooth_box_number"
                      :rules="[rules.required]"
                      :label="$t('drivers.createCaptain.bluetoothBoxNumber')"
                      type="text"
                      grow
                    >
                    </v-text-field>
                    <v-text-field
                      outline
                      v-model="model.license_number"
                      :rules="[rules.required]"
                      :label="$t('drivers.createCaptain.licensePlateNumber')"
                      type="text"
                      grow
                    ></v-text-field>

                    <v-select
                      outline
                      v-model="model.spoken_languages"
                      :label="$t('drivers.createCaptain.languages')"
                      :items="allLanguages"
                      multiple
                      dense
                    ></v-select>
                    <v-select
                      outline
                      v-model="model.vehicle_type"
                      :rules="[rules.required]"
                      item-text="name"
                      item-value="id"
                      :label="$t('drivers.createCaptain.vehicleTypes')"
                      :items="vehicleTypes"
                      dense
                      return-object
                    ></v-select>
                    <v-select
                      outline
                      v-model="model.constraints"
                      :label="$t('drivers.createCaptain.constraints')"
                      :items="car_constraints"
                      multiple
                      dense
                    ></v-select>
                 
                  </v-form>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6 grow pl-4>
              <v-layout align-start justify-start column>
                <h1 class="headline">{{ $t("drivers.createCaptain.documentsInfo") }}</h1>
                <v-flex xs12 mt-3 grow class="full-width">
                  <v-layout
                    style="gap: 20px; row-gap: 0px"
                    align-start
                    row
                    xs12
                    row
                    wrap
                  >
                    <upload-file
                      @change="model.assurance = $event"
                      :documentName="$t('drivers.createCaptain.assurance')"
                    />

                  
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-btn
            @click="
              addCaptain()
            "
            :loading="loading"
            color="secondary"
            class="tbtn"
            >{{ $t("drivers.createCaptain.addCaptain") }}</v-btn
          >
        </v-container>
      </v-tab-item>
    </v-tabs>
  </v-app>
</template>
<style>
.tbtn {
  float: right;
  margin-top: -40px;
  margin-right: 24px;
  padding: 0px 65px;
}
.docs {
  margin-bottom: 3px;
}
</style>
<script>
import axios from "axios";
import UploadFile from "@/components/widgets/UploadFile.vue";

export default {
  title() {
    return this.$t("drivers.createCaptain.title");
  },
  components: {
    UploadFile,
  },

  data: () => ({
    active: 0,

    loading: false,
    error: false,
    searchQuery: null,
    selectedBrands: [],
    allTest: [],
    brandsList: [],

    colorItem: { id: "", name: "" },
    colorsList: [],

    languageItem: { id: "", name: "" },
    spokenLanguagesList: [],
    spokenLanguagesIds: [],

    requiredDocuments: {},
    model: {
      //captain

      first_name: "",
      last_name: "",
      phone_number: "",
      email: "",
      password: "",
      gender: "",
      username: "", // Number of license
      spoken_languages: [],
      payment_method: "",
      driver_constraints: [],

      

    

      //vehicle

      brand: "",
      type: "",
      color: "",
      bluetooth_box_number: "",

      accepts_pets: 0,
      wheel_chair: 0,
      vehicle_type: "",
      license_number: "",

      constraints: [], //vehicle constraints
      insurance_document_front: "",
      car_document_front: "",

      assurance: "",
    
    
    },
    vehicleTypes: [],
    allBrands: [],
    allColors: [],
    allLanguages: [],
    allTypes: [],
    car_constraints: [],
    captain_constraints: [],

    form: false,
    isLoading: false,
    password: undefined,
  }),
  computed: {
    gender() {
      return [
        { text: this.$t("drivers.createCaptain.male"), value: "Male" },
        { text: this.$t("drivers.createCaptain.female"), value: "Female" },
      ];
    },
    payment() {
      return [
        { text: this.$t("drivers.createCaptain.cash"), value: "CASH" },
        { text: this.$t("drivers.createCaptain.paymentOption"), value: "PAYMENT" },
      ];
    },
    rules() {
      return {
        email: (v) => !!(v || "").match(/@/) || this.$t("drivers.createCaptain.validEmail"),
        length: (len) => (v) =>
          (v || "").length >= len || this.$t("drivers.createCaptain.invalidLength", { len }),
        password: (v) =>
          !!(v || "").match(/^.{8,15}$/) || this.$t("drivers.createCaptain.passwordLength"),
        phoneNumber: (v) =>
          (!!v &&
            v.search(
              /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
            ) !== -1) ||
          this.$t("drivers.createCaptain.invalidPhone"),

        required: (v) => !!v || this.$t("common.required"),
        numberOfLicense: (v) =>
          !!(v || "").match(/^[0-9]*$/) || this.$t("drivers.createCaptain.invalidLicense"),
      };
    },
  },
  mounted() {
    axios.get(this.api.ACTIONS.LANGUAGES).then((response) => {
      for (let i = 0; i < response.data.data.length; i++) {
        if(["English","French","Italian"].includes(response.data.data[i].name)){
          this.allLanguages.push(response.data.data[i].name);
          let obj = { id: "", name: "" };
          obj.id = response.data.data[i].id;
          obj.name = response.data.data[i].name;
          this.spokenLanguagesList.push(obj);
        }
       
      }
    });
    axios.get("vehicle_type").then((response) => {
      response.data.data.data.forEach((item) => {
        this.vehicleTypes.push({
          name: item.name,
          id: item.id,
        });
      });
      console.log(this.vehicleTypes);
    });

    axios.get(this.api.ACTIONS.CAR_BRANDS).then((response) => {
      // console.log(response.data.data);
      for (let i = 0; i < response.data.data.length; i++) {
        this.allBrands.push(response.data.data[i].name);
        let obj = { id: "", name: "" };
        obj.id = response.data.data[i].id;
        obj.name = response.data.data[i].name;
        this.brandsList.push(obj);
        // console.log(this.brandsList[i]);
      }
      console.log(this.brandsList);
    });

    axios.get(`dynamic_constraints`).then((data) => {
      data.data.data.data.forEach((cons) => {
        if(cons.entity_type == 'CAR'){
          this.car_constraints.push(cons.constraint_name);
        }
      });
    });

    axios.get(`dynamic_constraints`).then((data) => {
      data.data.data.data.forEach((cons) => {
        if(cons.entity_type == 'CAPTAIN'){
          this.captain_constraints.push('EXT', 'encompt', 'RESA');
          this.captain_constraints.push(cons.constraint_name);
        }
      });

      // this.captain_constraints = this.captain_constraints.filter(e => e.constraint_name !== 'PEXT');
    });

    axios.get(this.api.ACTIONS.COLORS).then((response) => {
      for (let i = 0; i < response.data.data.length; i++) {
        this.allColors.push(response.data.data[i].name);
        let obj = { id: "", name: "" };
        obj.id = response.data.data[i].id;
        obj.name = response.data.data[i].name;
        this.colorsList.push(obj);
      }
    });
  },

  methods: {
    testFunction() {
      console.log("ffs");
      console.log(this.model.type.id);
    },
    getTypes() {
      let id = "";
      // console.log(this.model.brand)
      // console.log(this.brandsList)
      for (let i = 0; i < this.brandsList.length; i++) {
        console.log(this.brandsList[i]);
        if (this.brandsList[i].name === this.model.brand)
          id = this.brandsList[i].id;
        // console.log(this.brandsList[i])
      }
      console.log(id);
      const typeUrl = this.api.ACTIONS.CAR_BRAND_MODELS(id);

      this.allTypes = [];
      axios.get(typeUrl).then((response) => {
        for (let i = 0; i < response.data.data.data.length; i++) {
          this.allTypes.push(response.data.data.data[i].name);
        }

        this.allTest = response.data.data.data;
        console.log("ALL TEST FFS");
        console.log(this.allTest);
      });
    },
    next() {
      const active = parseInt(this.active);
      this.active = active < 2 ? active + 1 : 0;
    },
    addCaptain() {
      if (this.$refs.form.validate()) {
        const formData = new FormData();
        const docsFormData = new FormData();

        // const formData=new FormData();
        // const formData=new FormData();
        this.model.gender = this.model.gender === "Male" ? 0 : 1;
        this.loading = true;

        formData.append("captain[gender]", this.model.gender);
        formData.append("captain[first_name]", this.model.first_name);
        formData.append("captain[last_name]", this.model.last_name);
        formData.append("captain[phone_number]", this.model.phone_number);
        formData.append("captain[username]", this.model.username);
        formData.append("captain[email]", this.model.email);
        formData.append("captain[password]", this.model.password);
        formData.append("captain[payment_method]", this.model.payment_method);
        //
      
        // formData.append("captain[attestation_nis]", this.model.attestation_nis);

        // formData.append("captain[livret_professionnel_expiry_date]", this.livret_professionnel_expiry_date);
        // formData.append("captain[electric_radio_license_expiry_date]", this.model.electric_radio_license_expiry_date);

      

        formData.append("car[brand_model_id]", this.model.type.id);
        for (let i = 0; i < this.colorsList.length; i++) {
          if (this.colorsList[i].name === this.model.color)
            formData.append("car[color_id]", this.colorsList[i].id);
        }

        console.log(this.spokenLanguagesList);
        this.model.spoken_languages.forEach((e) => {
          for (let i = 0; i < this.spokenLanguagesList.length; i++) {
            if (this.spokenLanguagesList[i].name === e)
              formData.append(
                "spoken_languages[]",
                this.spokenLanguagesList[i].id
              );
          }
        });

        // for (let i = 0; i < this.model.constraints.length; i++) {
        //   if (this.model.constraints[i] === "Pets") {
        //     this.model.accepts_pets = 1;
        //     formData.append("captain[accepts_pets]", this.model.accepts_pets);
        //   } else if (this.model.constraints[i] === "Wheelchair") {
        //     this.model.wheel_chair = 1;
        //     formData.append("captain[wheel_chair]", this.model.wheel_chair);
        //   }
        // }

        this.model.constraints.forEach((constraint) => {
          formData.append("car_constraints[]", constraint);
        });

        this.model.driver_constraints.forEach((constraint) => {
          formData.append("captain_constraints[]", constraint);
        });
        formData.append("captain_constraints[]", "PEXT");

        // for (let i = 0; i < this.car_constraints_list.length; i++) {
        //   for(let j=0;i<)

        // }
        // foreach(constraint in car_constraints_list);
        // {
        //   for (let i = 0; i < this.car_constraints_list.length; i++) {
        //     if (constraint.name == this.car_constraints_list[i])
        //       this.driver_constraints.push(constraint);
        //   }
        // }

        formData.append(
          "car[bluetooth_box_number]",
          this.model.bluetooth_box_number
        );
        formData.append("car[vehicle_type]", this.model.vehicle_type.id);

        formData.append("car[number]", this.model.license_number);

        formData.append("car[Attestation d'assurance]", this.model.assurance);
       
       

        // formData.append("captain",formData);
        // formData.append("car",formData);

        this.axios
          .post(this.api.ACTIONS.CAPTAINS, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            provider: "users",
          })
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("drivers.createCaptain.captainAdded"), "green");
            this.$router.push("/captains");
          })
          .catch((err) => {
            console.log(err.message);
            this.error = true;
            let response = err.response;
            if (response) {
              window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              console.log(response.data);
            } else {
              window.getApp.$emit("SHOW_TOAST", this.$t("drivers.createCaptain.checkYourInfo"), "red");

            }
          })
          .then(() => (this.loading = false));

        console.log(this.model);
      }
    },
  },
};
</script>
<style></style>
